












import { Component, Prop, Vue } from 'vue-property-decorator';
import { AbstractItemModel } from '@/models/items/abstract-item-model';
import { MediaItem } from '@/models/items/media-item-model';

import axios from 'axios';
import { UploadUtils } from '@/utils/upload-utils';
import AbstractAddItemGoogleSearchStep1 from '@/components/add-flows/AbstractAddItem-GoogleSearch-Step1.vue';

import {GOOGLE_CUSTOM_SEARCH_CX_MEDIA, GOOGLE_CUSTOM_SEARCH_API_KEY_MEDIA, IFRAMELY_API_KEY} from '@/secrets';

@Component({components: {AbstractAddItemGoogleSearchStep1}})
export default class AddMediaItem_Step1 extends Vue {
  item = new MediaItem();

  public goToNextStep(args: any) {
    const self = this;
    if (this.item.url) {
      axios({
        url: 'https://iframe.ly/api/iframely',
        params: {
          api_key: IFRAMELY_API_KEY,
          url: this.item.url
        }
      }).then(function(response) {
        // handle success
        
        
        

        self.item.artist = response.data.meta.author || '';
        self.item.title = response.data.meta.title || '';
        self.$emit('go-to-next-step', args);
      });
    } else {
         self.$emit('go-to-next-step', args);
    }
  }

  get searchCx() { 
    return GOOGLE_CUSTOM_SEARCH_CX_MEDIA;
  }

  get searchKey() { 
    return GOOGLE_CUSTOM_SEARCH_API_KEY_MEDIA;
  }
}
